import { render, staticRenderFns } from "./changeRemark.vue?vue&type=template&id=43c278f8&scoped=true"
import script from "./changeRemark.vue?vue&type=script&lang=ts"
export * from "./changeRemark.vue?vue&type=script&lang=ts"
import style0 from "./changeRemark.vue?vue&type=style&index=0&id=43c278f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c278f8",
  null
  
)

export default component.exports